// Abstrakte, hochwertige Platzhalter-Visuals ("Light Studies").
// Bewusste künstlerische Entscheidung bis echte Fotos/Artworks geliefert werden:
// Jede Variante ist eine komponierte Licht-Atmosphäre (Gradienten + Grain + Vignette).
const VARIANTS = {
  hero: [
    "radial-gradient(58% 46% at 63% 38%, rgba(112,199,250,0.34) 0%, rgba(56,189,248,0.10) 46%, rgba(7,7,9,0) 76%)",
    "radial-gradient(42% 34% at 18% 88%, rgba(216,207,191,0.10) 0%, rgba(7,7,9,0) 70%)",
    "linear-gradient(115deg, rgba(7,7,9,0) 44%, rgba(112,199,250,0.07) 50%, rgba(7,7,9,0) 56%)",
    "linear-gradient(165deg, #0d0d13 0%, #070709 60%, #050506 100%)",
  ],
  core: [
    "radial-gradient(46% 46% at 50% 46%, rgba(112,199,250,0.55) 0%, rgba(56,189,248,0.16) 42%, rgba(7,7,9,0) 72%)",
    "radial-gradient(70% 60% at 80% 90%, rgba(216,207,191,0.08) 0%, rgba(7,7,9,0) 65%)",
    "linear-gradient(160deg, #101018 0%, #070709 72%)",
  ],
  beam: [
    "linear-gradient(112deg, rgba(7,7,9,0) 38%, rgba(112,199,250,0.28) 49%, rgba(56,189,248,0.10) 53%, rgba(7,7,9,0) 62%)",
    "radial-gradient(50% 40% at 75% 20%, rgba(112,199,250,0.14) 0%, rgba(7,7,9,0) 70%)",
    "linear-gradient(150deg, #0e0e15 0%, #070709 70%)",
  ],
  horizon: [
    "radial-gradient(90% 46% at 50% 108%, rgba(112,199,250,0.30) 0%, rgba(56,189,248,0.08) 52%, rgba(7,7,9,0) 78%)",
    "linear-gradient(180deg, #0c0c12 0%, #070709 80%)",
  ],
  ember: [
    "radial-gradient(52% 44% at 30% 70%, rgba(216,207,191,0.20) 0%, rgba(7,7,9,0) 68%)",
    "radial-gradient(34% 30% at 78% 24%, rgba(112,199,250,0.16) 0%, rgba(7,7,9,0) 70%)",
    "linear-gradient(140deg, #111016 0%, #070709 75%)",
  ],
  veil: [
    "radial-gradient(60% 48% at 30% 18%, rgba(163,163,172,0.16) 0%, rgba(7,7,9,0) 70%)",
    "linear-gradient(105deg, rgba(7,7,9,0) 46%, rgba(112,199,250,0.10) 52%, rgba(7,7,9,0) 58%)",
    "linear-gradient(170deg, #0f0f15 0%, #070709 78%)",
  ],
  void: [
    "radial-gradient(44% 38% at 60% 60%, rgba(163,163,172,0.10) 0%, rgba(7,7,9,0) 72%)",
    "linear-gradient(160deg, #0d0d12 0%, #060608 80%)",
  ],
};

export default function Artwork({ variant = "void", className = "", breathe = false, glow = false, image = null, alt = "", children }) {
  return (
    <div className={`relative overflow-hidden bg-[#0b0b10] ${className}`}>
      {image ? (
        <img
          src={image}
          alt={alt}
          loading="lazy"
          className={`absolute inset-0 w-full h-full object-cover ${breathe ? "animate-breathe" : ""} ${glow ? "animate-pulse-glow" : ""}`}
        />
      ) : (
        <div
          className={`absolute inset-0 ${breathe ? "animate-breathe" : ""} ${glow ? "animate-pulse-glow" : ""}`}
          style={{ background: (VARIANTS[variant] || VARIANTS.void).join(",") }}
        />
      )}
      <div className="absolute inset-0 grain opacity-[0.10] mix-blend-overlay" />
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(125% 125% at 50% 50%, transparent 58%, rgba(0,0,0,0.42) 100%)" }}
      />
      {children}
    </div>
  );
}
